import { render, staticRenderFns } from "./WpItemsView.vue?vue&type=template&id=7e6743f8&"
import script from "./WpItemsView.vue?vue&type=script&lang=js&"
export * from "./WpItemsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports